module.exports = __webpack_public_path__ + "static/media/beautifulLives-mockup.3961b0eb.png";